module.exports = __webpack_public_path__ + "static/media/pic5.87137570.jpg";